import { createFeatureSelector, createSelector } from '@ngrx/store';
import { isNullOrUndefined } from '@uzurv/core';
import * as dispatchReducer from './dispatch.reducer';

export const getDispatchState = createFeatureSelector<dispatchReducer.DispatchState>(dispatchReducer.dispatchFeatureKey);

export const getLoading = createSelector(getDispatchState, state => state.loading);

export const getProviderId = createSelector(getDispatchState, state => state.providerId);

export const getPageNumber = createSelector(getDispatchState, state => state.pageNumber);

export const getPageSize = createSelector(getDispatchState, state => state.pageSize);

export const getProviderSearchString = createSelector(getDispatchState, state => state.providerSearchString);

export const getProviders = createSelector(getDispatchState, state => state.providers);

export const getProviderForCurrentUser = createSelector(getDispatchState, state => {
  if (state.providers?.length > 0) {
    return state.providers.find(provider => provider.id === state.providerId);
  }
});

export const getProviderDetail = (id: number) => createSelector(getDispatchState, state => state.providerDetails[id]);

export const getTransitPrograms = (id: number) =>
  createSelector(getDispatchState, state => state.providerDetails[id]?.providerTransitPrograms);

export const getSelectedFeeScheduleStatus = (id: number) =>
  createSelector(getDispatchState, state => state?.providerDetails[id]?.selectedFeeScheduleStatus);

export const getProviderFeeScheduleFormData = (id: number) =>
  createSelector(getDispatchState, state => state.providerDetails[id]?.providerFeeScheduleFormData);

export const getServiceLevels = createSelector(getDispatchState, state => state.serviceLevels);

export const getFareCalculators = createSelector(getDispatchState, state => state.fareCalculators);

export const getUsersByClientApproverRole = createSelector(getDispatchState, state => state.usersByClientApproverRole);

export const getUsersByProviderApproverRole = createSelector(getDispatchState, state => state.usersByProviderApproverRole);

export const getProviderFeeScheduleApprovalStatusesForProviderServiceLevel = createSelector(getDispatchState, state => {
  return state.providerDetails[state.providerId]?.providerFeeScheduleApprovalStatusesForProviderServiceLevel;
});

export const getSelectedProviderFeeScheduleApprovalObjectInfo = createSelector(
  getDispatchState,
  state => state.providerDetails[state.providerId]?.selectedProviderFeeScheduleApprovalObjectInfo
);

export const getEditing = createSelector(getDispatchState, state => state.providerDetails[state.providerId]?.editing);

export const getHasModifiedFareCalculator = createSelector(getDispatchState, state => {
  if (isNullOrUndefined(state.providerDetails[state.providerId])) {
    return false;
  }
  return state.providerDetails[state.providerId]?.hasModifiedFareCalculator;
});

export const getShouldDisplayProviderFeeScheduleApprovalStatusList = createSelector(
  getDispatchState,
  state => state.providerDetails[state.providerId]?.shouldDisplayProviderFeeScheduleApprovalStatusList
);

export const getDispatchers = createSelector(getDispatchState, state => state.dispatchers);

export const getTenants = createSelector(getDispatchState, state => state.tenants);

export const getDrivers = createSelector(getDispatchState, state => state.drivers);

export const getAutocompleteResults = createSelector(getDispatchState, state => state.autocompleteResults);

export const getMapInitialized = createSelector(getDispatchState, state => state.mapInitialized);

export const getMapCenter = createSelector(getDispatchState, state => state.mapCenter);

export const getRidesTab = createSelector(getDispatchState, state => state.ridesTab);

export const getRides = createSelector(getDispatchState, state => state.rides);

export const getPinnedRides = createSelector(getDispatchState, state => state.pinnedRides);

export const getDeferHoverEvents = createSelector(getDispatchState, state => state.deferHoverEvents);

export const isItineraryFocused = createSelector(getDispatchState, state => state.isItineraryFocused);

export const getFocusedItineraryRides = createSelector(getDispatchState, state => state.focusedItineraryRides);

export const getFocusedItineraryRiderName = createSelector(getDispatchState, state => state.focusedItineraryRiderName);

export const getOnDemandRides = createSelector(getDispatchState, state => state.onDemandRides);

export const getOffPlatformReservations = createSelector(getDispatchState, state => state.offPlatformReservations);
